<template>
  <div id="content" class="mobile">
    <MapMobile ref="refMapMobile" :key="key" mapId="koreaMap" style="width: 100vw;height: calc(100vh - 50px);"></MapMobile>
    <DataBoard ref="refDataBoard" ></DataBoard>
    <MapLocationBoard ref="refMapLocationBoard" ></MapLocationBoard>
  </div>
</template>

<script>

import MapMobile from '@/components/MapMobile'
import DataBoard from '@/components/DataBoard'
import MapLocationBoard from '@/components/MapLocationBoard'

export default {
  name: 'Contents',
  components: {
    MapMobile,
    DataBoard,
    MapLocationBoard
  },
  computed: {
    key () {
      return this.$route.path
    }
  }
}
</script>

<style scoped>

</style>
